import { useState } from 'react';
import { resolveAvatarUrl } from '../lib/avatarUrl';

// Keying the stateful image by its resolved URL gives every new source a fresh
// load attempt, without reassigning src or retrying the failed source.
function HostAvatarImage({ src, username }) {
  const [failed, setFailed] = useState(false);
  if (src && !failed) {
    return <img src={src} alt="" className="w-8 h-8 rounded-full object-cover" onError={() => setFailed(true)} />;
  }
  return (
    <div className="w-8 h-8 rounded-full bg-zinc-200 flex items-center justify-center text-zinc-500 text-xs font-semibold">
      {(username || '?').slice(0, 2).toUpperCase()}
    </div>
  );
}

export default function AdminHostAvatar({ imageUrl, username }) {
  const src = resolveAvatarUrl(imageUrl);
  return <HostAvatarImage key={src || ''} src={src} username={username} />;
}
